// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReportUserModal_footer__3Geqm","label":"ReportUserModal_label__3sq7e"};